(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky && this.header) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      setHeaderHeight() {
        if (!this.header) return;
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        if (!this.header) return;

        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        if (!this.header) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky || !this.header) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky || !this.header) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky || !this.header) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        if (!this.header) return;
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach((disclosure) => disclosure.close());
      }

      closeSearchModal() {
        if (!this.header) return;
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        if (this.searchModal) this.searchModal.close(false);
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (!form.matches('.cs-desktop-search-form, .cs-mobile-search-form')) return;

    const visibleInput = form.querySelector('.cs-desktop-search-input, .cs-mobile-search-input');
    const hiddenInput = form.querySelector('.cs-hidden-search-value');

    if (visibleInput && hiddenInput) {
      hiddenInput.value = visibleInput.value;
    }
  });




  (function () {
    'use strict';

    if (window.CsuriHeaderPopupManager && typeof window.CsuriHeaderPopupManager.destroy === 'function') {
      window.CsuriHeaderPopupManager.destroy();
    }

    const SELECTORS = {
      config: '[data-cs-header-popup-config]',
      accountTrigger: '[data-cs-account-menu-trigger]',
      wishlistTrigger: '[data-cs-wishlist-menu-trigger]',
      close: '[data-cs-header-popup-close]',
      directLink: '[data-cs-account-direct-link], [data-cs-wishlist-direct-link]'
    };

    const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
    let active = null;
    let portal = null;
    let backdrop = null;
    let rafId = 0;
    let lockedScrollY = 0;
    let savedBodyStyle = null;
    let savedHtmlOverflow = '';

    function getConfigElement() {
      return document.querySelector(SELECTORS.config);
    }

    function parseBoolean(value, fallback) {
      if (value === undefined || value === null || value === '') return Boolean(fallback);
      return String(value).toLowerCase() === 'true';
    }

    function parseNumber(value, fallback) {
      const number = Number(value);
      return Number.isFinite(number) ? number : fallback;
    }

    function getSettings() {
      const config = getConfigElement();
      const dataset = config ? config.dataset : {};

      return {
        closeOnBackdrop: parseBoolean(dataset.closeOnBackdrop, true),
        closeOnEscape: parseBoolean(dataset.closeOnEscape, true),
        lockMobileScroll: parseBoolean(dataset.lockMobileScroll, true),
        showCloseButton: parseBoolean(dataset.showCloseButton, true),
        mobilePosition: dataset.mobilePosition === 'bottom' ? 'bottom' : 'center',
        closeLabel: dataset.closeLabel || 'Popup bezárása',
        desktopGap: Math.max(0, parseNumber(dataset.desktopGap, 10)),
        edgeMargin: Math.max(0, parseNumber(dataset.edgeMargin, 16))
      };
    }

    function isMobile() {
      return MOBILE_QUERY.matches;
    }

    function getTriggerData(target) {
      if (!target || typeof target.closest !== 'function') return null;

      const accountTrigger = target.closest(SELECTORS.accountTrigger);
      if (accountTrigger) return { trigger: accountTrigger, kind: 'account' };

      const wishlistTrigger = target.closest(SELECTORS.wishlistTrigger);
      if (wishlistTrigger) return { trigger: wishlistTrigger, kind: 'wishlist' };

      return null;
    }

    function getPanel(trigger, kind) {
      if (!trigger) return null;

      const controlledId = trigger.getAttribute('aria-controls');
      if (controlledId) {
        const controlledPanel = document.getElementById(controlledId);
        if (controlledPanel) return controlledPanel;
      }

      const wrapperSelector = kind === 'account'
        ? '[data-cs-account-menu-wrapper]'
        : '[data-cs-wishlist-menu-wrapper]';
      const panelSelector = kind === 'account'
        ? '[data-cs-account-menu]'
        : '[data-cs-wishlist-menu]';
      const wrapper = trigger.closest(wrapperSelector);
      return wrapper ? wrapper.querySelector(panelSelector) : null;
    }

    function preventTriggerNavigation(event) {
      event.preventDefault();
      event.stopPropagation();
    }

    function ensurePortal() {
      if (!document.body) return null;

      if (!portal || !portal.isConnected) {
        portal = document.createElement('div');
        portal.className = 'cs-header-popup-layer';
        portal.setAttribute('data-cs-header-popup-layer', '');
        portal.setAttribute('aria-hidden', 'true');

        backdrop = document.createElement('button');
        backdrop.type = 'button';
        backdrop.className = 'cs-header-popup-backdrop';
        backdrop.setAttribute('data-cs-header-popup-backdrop', '');
        backdrop.setAttribute('aria-label', 'Popup bezárása');
        backdrop.tabIndex = -1;

        portal.appendChild(backdrop);
      }

      document.body.appendChild(portal);
      portal.classList.toggle('is-mobile', isMobile());
      portal.style.setProperty('z-index', isMobile() ? '2147483647' : '2147483646', 'important');
      return portal;
    }

    function createOrUpdateCloseButton(panel, settings) {
      let button = panel.querySelector(':scope > [data-cs-header-popup-close]');

      if (!settings.showCloseButton) {
        if (button) button.remove();
        return null;
      }

      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'cs-header-popup__close';
        button.setAttribute('data-cs-header-popup-close', '');
        button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"></path></svg>';
        panel.prepend(button);
      }

      button.setAttribute('aria-label', settings.closeLabel);
      return button;
    }

    function setTriggerState(trigger, open) {
      if (!trigger) return;
      trigger.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function getFocusable(panel) {
      return Array.from(panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) {
        return element.offsetParent !== null && !element.hasAttribute('hidden');
      });
    }

    function lockScroll(settings) {
      if (!settings.lockMobileScroll || !isMobile() || savedBodyStyle || !document.body) return;

      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      savedHtmlOverflow = document.documentElement.style.overflow;
      savedBodyStyle = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width,
        overflow: document.body.style.overflow
      };

      document.documentElement.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + lockedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.classList.add('cs-header-mobile-popup-open');
      document.body.classList.add('cs-header-mobile-popup-open');
    }

    function unlockScroll() {
      document.documentElement.classList.remove('cs-header-mobile-popup-open');
      if (document.body) document.body.classList.remove('cs-header-mobile-popup-open');

      if (!savedBodyStyle || !document.body) return;

      document.body.style.position = savedBodyStyle.position;
      document.body.style.top = savedBodyStyle.top;
      document.body.style.left = savedBodyStyle.left;
      document.body.style.right = savedBodyStyle.right;
      document.body.style.width = savedBodyStyle.width;
      document.body.style.overflow = savedBodyStyle.overflow;
      document.documentElement.style.overflow = savedHtmlOverflow;

      savedBodyStyle = null;
      savedHtmlOverflow = '';
      window.scrollTo(0, lockedScrollY);
    }

    function restorePanel(state) {
      if (!state || !state.panel) return;

      const panel = state.panel;
      panel.classList.remove(
        'is-open',
        'cs-header-popup-panel',
        'cs-header-popup-panel--account',
        'cs-header-popup-panel--wishlist'
      );
      panel.setAttribute('aria-hidden', 'true');
      panel.removeAttribute('aria-modal');
      panel.removeAttribute('tabindex');
      panel.removeAttribute('aria-label');
      panel.style.removeProperty('--cs-header-popup-top');
      panel.style.removeProperty('--cs-header-popup-right');
      panel.style.removeProperty('--cs-header-popup-mobile-center');

      if (state.originalRole) panel.setAttribute('role', state.originalRole);
      else panel.removeAttribute('role');

      if (state.placeholder && state.placeholder.parentNode) {
        state.placeholder.parentNode.insertBefore(panel, state.placeholder);
        state.placeholder.remove();
      } else if (state.originParent && state.originParent.isConnected) {
        state.originParent.appendChild(panel);
      }
    }

    function close(options) {
      const closeOptions = options || {};
      const state = active;
      active = null;

      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = 0;
      }

      if (!state) {
        unlockScroll();
        return;
      }

      setTriggerState(state.trigger, false);
      state.panel.classList.remove('is-open');
      state.panel.setAttribute('aria-hidden', 'true');

      if (portal) {
        portal.classList.remove('is-open');
        portal.setAttribute('aria-hidden', 'true');
      }

      document.documentElement.classList.remove('cs-header-popup-open');
      if (document.body) document.body.classList.remove('cs-header-popup-open');
      unlockScroll();
      restorePanel(state);

      if (closeOptions.restoreFocus !== false && state.trigger && state.trigger.isConnected) {
        state.trigger.focus({ preventScroll: true });
      }
    }

    function positionPopup() {
      if (!active || !active.trigger || !active.panel) return;

      const settings = getSettings();
      const panel = active.panel;

      if (isMobile()) {
        panel.style.removeProperty('--cs-header-popup-top');
        panel.style.removeProperty('--cs-header-popup-right');

        if (settings.mobilePosition === 'bottom') {
          panel.style.removeProperty('--cs-header-popup-mobile-center');
          return;
        }

        const viewport = window.visualViewport;
        const centerY = viewport
          ? viewport.offsetTop + (viewport.height / 2)
          : window.innerHeight / 2;
        panel.style.setProperty('--cs-header-popup-mobile-center', centerY + 'px');
        return;
      }

      panel.style.removeProperty('--cs-header-popup-mobile-center');
      const triggerRect = active.trigger.getBoundingClientRect();
      const margin = settings.edgeMargin;
      const proposedTop = Math.max(margin, triggerRect.bottom + settings.desktopGap);
      const right = Math.max(margin, window.innerWidth - triggerRect.right);

      panel.style.setProperty('--cs-header-popup-top', proposedTop + 'px');
      panel.style.setProperty('--cs-header-popup-right', right + 'px');

      const panelHeight = panel.offsetHeight;
      const maxTop = Math.max(margin, window.innerHeight - panelHeight - margin);
      panel.style.setProperty('--cs-header-popup-top', Math.min(proposedTop, maxTop) + 'px');
    }

    function syncOpenMode() {
      if (!active || !portal) return;

      const settings = getSettings();
      portal.classList.toggle('is-mobile', isMobile());
      portal.style.setProperty('z-index', isMobile() ? '2147483647' : '2147483646', 'important');
      if (backdrop) backdrop.setAttribute('aria-label', settings.closeLabel);

      if (isMobile()) lockScroll(settings);
      else unlockScroll();

      positionPopup();
    }

    function schedulePosition() {
      if (!active) return;
      if (rafId) window.cancelAnimationFrame(rafId);
      rafId = window.requestAnimationFrame(function () {
        rafId = 0;
        syncOpenMode();
      });
    }

    function open(trigger, panel, kind) {
      if (!trigger || !panel || !document.body) return;

      if (active && active.trigger === trigger) {
        close();
        return;
      }

      close({ restoreFocus: false });
      const currentPortal = ensurePortal();
      if (!currentPortal) return;

      const placeholder = document.createComment('cs-header-popup-placeholder');
      const originParent = panel.parentNode;
      if (!originParent) return;
      originParent.insertBefore(placeholder, panel);

      active = {
        trigger: trigger,
        panel: panel,
        kind: kind,
        placeholder: placeholder,
        originParent: originParent,
        originalRole: panel.getAttribute('role') || ''
      };

      const settings = getSettings();
      setTriggerState(trigger, true);
      createOrUpdateCloseButton(panel, settings);

      panel.classList.add('cs-header-popup-panel', 'cs-header-popup-panel--' + kind);
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-hidden', 'false');
      panel.setAttribute('tabindex', '-1');
      panel.setAttribute('aria-label', trigger.getAttribute('aria-label') || (kind === 'account' ? 'Fiók' : 'Kívánságlista'));

      currentPortal.appendChild(panel);
      document.body.appendChild(currentPortal);
      currentPortal.classList.add('is-open');
      currentPortal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cs-header-popup-open');
      document.body.classList.add('cs-header-popup-open');

      syncOpenMode();

      window.requestAnimationFrame(function () {
        if (!active || active.panel !== panel) return;
        panel.classList.add('is-open');
        const focusTarget = panel.querySelector(SELECTORS.close) || getFocusable(panel)[0] || panel;
        focusTarget.focus({ preventScroll: true });
      });
    }

    function onDocumentClick(event) {
      const target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      const triggerData = getTriggerData(target);
      if (triggerData) {
        preventTriggerNavigation(event);
        const panel = getPanel(triggerData.trigger, triggerData.kind);
        if (panel) open(triggerData.trigger, panel, triggerData.kind);
        return;
      }

      if (!active) return;

      if (target.closest(SELECTORS.close)) {
        event.preventDefault();
        close();
        return;
      }

      if (target.closest(SELECTORS.directLink)) {
        close({ restoreFocus: false });
        return;
      }

      const settings = getSettings();
      if (!settings.closeOnBackdrop) return;

      if (target.closest('[data-cs-header-popup-backdrop]')) {
        event.preventDefault();
        close({ restoreFocus: false });
        return;
      }

      if (!active.panel.contains(target) && !active.trigger.contains(target)) {
        close({ restoreFocus: false });
      }
    }

    function onKeydown(event) {
      if (!active) return;
      const settings = getSettings();

      if (event.key === 'Escape') {
        if (settings.closeOnEscape) {
          event.preventDefault();
          close();
        }
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = getFocusable(active.panel);
      if (!focusable.length) {
        event.preventDefault();
        active.panel.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function onSectionUnload(event) {
      if (!active || !event.target) return;
      if (event.target.contains(active.trigger) || event.target.contains(active.originParent)) {
        close({ restoreFocus: false });
      }
    }

    function destroy() {
      close({ restoreFocus: false });
      document.removeEventListener('click', onDocumentClick, true);
      document.removeEventListener('keydown', onKeydown);
      document.removeEventListener('shopify:section:unload', onSectionUnload);
      window.removeEventListener('resize', schedulePosition);
      window.removeEventListener('scroll', schedulePosition, true);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', schedulePosition);
        window.visualViewport.removeEventListener('scroll', schedulePosition);
      }
      if (MOBILE_QUERY.removeEventListener) MOBILE_QUERY.removeEventListener('change', schedulePosition);
      else if (MOBILE_QUERY.removeListener) MOBILE_QUERY.removeListener(schedulePosition);

      if (portal && portal.isConnected) portal.remove();
      portal = null;
      backdrop = null;
    }

    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    window.addEventListener('resize', schedulePosition);
    window.addEventListener('scroll', schedulePosition, true);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedulePosition);
      window.visualViewport.addEventListener('scroll', schedulePosition);
    }
    if (MOBILE_QUERY.addEventListener) MOBILE_QUERY.addEventListener('change', schedulePosition);
    else if (MOBILE_QUERY.addListener) MOBILE_QUERY.addListener(schedulePosition);

    window.CsuriHeaderPopupManager = {
      version: '2.0.0',
      close: close,
      destroy: destroy,
      openAccount: function () {
        const trigger = document.querySelector(SELECTORS.accountTrigger);
        const panel = getPanel(trigger, 'account');
        if (trigger && panel) open(trigger, panel, 'account');
      },
      openWishlist: function () {
        const trigger = document.querySelector(SELECTORS.wishlistTrigger);
        const panel = getPanel(trigger, 'wishlist');
        if (trigger && panel) open(trigger, panel, 'wishlist');
      }
    };
  })();



  (function () {
    if (window.CsuriWishlist && window.CsuriWishlist.version === '2.0.0') {
      window.CsuriWishlist.refresh();
      return;
    }

    const STORAGE_KEY = 'csuri-wishlist';
    const LEGACY_STORAGE_KEYS = ['csuriWishlist', 'csuri_wishlist'];
    const UPDATE_EVENT = 'csuri:wishlist:updated';
    const TOGGLE_EVENT = 'csuri:wishlist:toggled';
    const popupConfig = document.querySelector('[data-cs-header-popup-config]');
    const HEADER_WISHLIST_PREVIEW_COUNT = Math.max(0, Number(popupConfig?.dataset.wishlistPreviewCount || 3));

    function normalizeText(value) {
      return value === null || value === undefined ? '' : String(value).trim();
    }

    function normalizeId(value) {
      const normalized = normalizeText(value);
      return normalized
        .replace(/^gid:\/\/shopify\/Product\//, '')
        .replace(/^gid:\/\/shopify\/ProductVariant\//, '');
    }

    function normalizeNumber(value, fallback) {
      if (value === null || value === undefined || value === '') return fallback;
      const normalized = typeof value === 'string'
        ? value.replace(/\s+/g, '').replace(',', '.')
        : value;
      const number = Number(normalized);
      return Number.isFinite(number) ? number : fallback;
    }

    function normalizeNullableNumber(value) {
      return normalizeNumber(value, null);
    }

    function normalizeBoolean(value, fallback) {
      if (value === null || value === undefined || value === '') return Boolean(fallback);
      if (value === true || value === 1 || value === '1') return true;
      if (value === false || value === 0 || value === '0') return false;
      const normalized = normalizeText(value).toLowerCase();
      if (['true', 'yes', 'igen', 'on'].includes(normalized)) return true;
      if (['false', 'no', 'nem', 'off'].includes(normalized)) return false;
      return Boolean(fallback);
    }

    function normalizeArray(value) {
      if (Array.isArray(value)) {
        return value.map(normalizeText).filter(Boolean);
      }

      if (value === null || value === undefined || value === '') return [];

      if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) return [];

        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) return parsed.map(normalizeText).filter(Boolean);
        } catch (error) {}

        return trimmed
          .split(/[,|;]+/)
          .map(normalizeText)
          .filter(Boolean);
      }

      return [normalizeText(value)].filter(Boolean);
    }

    function getDatasetValue(dataset, keys) {
      for (const key of keys) {
        if (dataset && dataset[key] !== undefined && dataset[key] !== '') return dataset[key];
      }
      return '';
    }

    function normalizeItem(item) {
      if (item === null || item === undefined) return null;

      if (typeof item === 'string' || typeof item === 'number') {
        const primitiveId = normalizeId(item);
        return primitiveId
          ? { id: primitiveId, productId: primitiveId, addedAt: Date.now() }
          : null;
      }

      if (typeof item !== 'object') return null;

      const handle = normalizeText(item.handle || item.productHandle || item.product_handle);
      const url = normalizeText(item.url || item.productUrl || item.product_url);
      const rawProductId = item.productId || item.product_id || item.productID || item.id;
      const productId = normalizeId(rawProductId) || (handle ? 'handle:' + handle : url ? 'url:' + url : '');

      if (!productId) return null;

      const priceValue = normalizeNullableNumber(
        item.priceValue ?? item.price_value ?? item.priceCents ?? item.price_cents
      );
      const compareAtPriceValue = normalizeNullableNumber(
        item.compareAtPriceValue ?? item.compare_at_price_value ?? item.compareAtPriceCents ?? item.compare_at_price_cents
      );
      const stockQuantity = normalizeNullableNumber(
        item.stockQuantity ?? item.stock_quantity ?? item.inventoryQuantity ?? item.inventory_quantity
      );
      const ratingValue = normalizeNullableNumber(item.ratingValue ?? item.rating_value ?? item.rating);
      const ratingCount = normalizeNullableNumber(item.ratingCount ?? item.rating_count ?? item.reviewCount ?? item.review_count);

      return {
        id: productId,
        productId: productId,
        variantId: normalizeId(item.variantId || item.variant_id || item.variantID),
        handle: handle,
        url: url,
        title: normalizeText(item.title || item.productTitle || item.product_title),
        vendor: normalizeText(item.vendor || item.brand),
        image: normalizeText(item.image || item.imageUrl || item.image_url || item.featuredImage || item.featured_image),
        price: normalizeText(item.price || item.formattedPrice || item.formatted_price),
        compareAtPrice: normalizeText(item.compareAtPrice || item.compare_at_price || item.formattedCompareAtPrice),
        priceValue: priceValue,
        compareAtPriceValue: compareAtPriceValue,
        available: normalizeBoolean(item.available, false),
        preorder: normalizeBoolean(item.preorder ?? item.isPreorder ?? item.is_preorder, false),
        soldOut: normalizeBoolean(item.soldOut ?? item.sold_out ?? item.isSoldOut, false),
        status: normalizeText(item.status || item.stockStatus || item.stock_status),
        ratingValue: ratingValue,
        ratingCount: ratingCount,
        fragranceFamily: normalizeArray(item.fragranceFamily ?? item.fragrance_family),
        usageTime: normalizeArray(item.usageTime ?? item.usage_time ?? item.bestTime ?? item.best_time),
        season: normalizeArray(item.season ?? item.seasons),
        gender: normalizeArray(item.gender ?? item.genders),
        stockQuantity: stockQuantity,
        stockQuantityIsLive: normalizeBoolean(
          item.stockQuantityIsLive ?? item.stock_quantity_is_live ?? item.inventoryIsLive,
          false
        ),
        expectedArrival: normalizeText(item.expectedArrival || item.expected_arrival || item.preorderEta || item.preorder_eta),
        tags: normalizeArray(item.tags),
        addedAt: normalizeNumber(item.addedAt || item.added_at, Date.now())
      };
    }

    function itemScore(item) {
      return Object.values(item || {}).reduce(function (score, value) {
        if (Array.isArray(value)) return score + value.length;
        if (value === null || value === undefined || value === '' || value === false) return score;
        return score + 1;
      }, 0);
    }

    function normalizeItems(value) {
      let source = value;

      if (source && !Array.isArray(source) && typeof source === 'object') {
        source = source.items || source.products || source.wishlist || [];
      }

      if (!Array.isArray(source)) return [];

      const unique = new Map();

      source.forEach(function (rawItem) {
        const item = normalizeItem(rawItem);
        if (!item) return;

        const existing = unique.get(item.productId);
        if (!existing) {
          unique.set(item.productId, item);
          return;
        }

        const newer = item.addedAt >= existing.addedAt ? item : existing;
        const richer = itemScore(item) >= itemScore(existing) ? item : existing;
        unique.set(
          item.productId,
          Object.assign({}, existing, item, richer, { addedAt: newer.addedAt })
        );
      });

      return Array.from(unique.values()).sort(function (a, b) {
        return Number(b.addedAt || 0) - Number(a.addedAt || 0);
      });
    }

    function parseStoredValue(rawValue) {
      if (!rawValue) return [];

      try {
        return normalizeItems(JSON.parse(rawValue));
      } catch (error) {
        return normalizeItems(rawValue.split(',').map(function (value) { return value.trim(); }));
      }
    }

    function readItems() {
      try {
        const currentItems = parseStoredValue(localStorage.getItem(STORAGE_KEY));
        if (currentItems.length || localStorage.getItem(STORAGE_KEY) === '[]') return currentItems;

        for (const legacyKey of LEGACY_STORAGE_KEYS) {
          const legacyItems = parseStoredValue(localStorage.getItem(legacyKey));
          if (legacyItems.length) {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(legacyItems));
            return legacyItems;
          }
        }
      } catch (error) {
        console.warn('[CsuriWishlist] A wishlist nem olvasható.', error);
      }

      return [];
    }

    function dispatchUpdate(items, source) {
      const detail = {
        items: items.slice(),
        count: items.length,
        source: source || 'api',
        storageKey: STORAGE_KEY
      };

      window.dispatchEvent(new CustomEvent(UPDATE_EVENT, { detail: detail }));
      document.dispatchEvent(new CustomEvent(UPDATE_EVENT, { detail: detail }));
    }

    function writeItems(items, source) {
      const normalizedItems = normalizeItems(items);

      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(normalizedItems));
      } catch (error) {
        console.warn('[CsuriWishlist] A wishlist nem menthető.', error);
      }

      renderAll(normalizedItems);
      dispatchUpdate(normalizedItems, source || 'api');
      return normalizedItems;
    }

    function safeLink(value) {
      const url = normalizeText(value);
      if (!url) return '#';
      if (url.startsWith('/') || url.startsWith('#')) return url;

      try {
        const parsed = new URL(url, window.location.origin);
        if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.href;
      } catch (error) {}

      return '#';
    }

    function safeImage(value) {
      const url = normalizeText(value);
      if (!url) return '';
      if (url.startsWith('/') || url.startsWith('//')) return url;

      try {
        const parsed = new URL(url, window.location.origin);
        if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.href;
      } catch (error) {}

      return '';
    }

    function formatPrice(value, currency) {
      const numericValue = normalizeNullableNumber(value);
      if (numericValue === null) return '';

      try {
        return new Intl.NumberFormat('hu-HU', {
          style: 'currency',
          currency: currency || 'HUF',
          maximumFractionDigits: 0
        }).format(numericValue / 100);
      } catch (error) {
        return Math.round(numericValue / 100).toLocaleString('hu-HU') + ' Ft';
      }
    }

    function createHeartPlaceholder() {
      const placeholder = document.createElement('span');
      placeholder.className = 'cs-wishlist-menu__preview-placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20.8 4.6C19.9 3.6 18.7 3 17.4 3C15.9 3 14.5 3.8 13.6 5L12 7L10.4 5C9.5 3.8 8.1 3 6.6 3C5.3 3 4.1 3.6 3.2 4.6C1.4 6.6 1.5 9.7 3.5 11.7L12 20L20.5 11.7C22.5 9.7 22.6 6.6 20.8 4.6Z"></path></svg>';
      return placeholder;
    }

    function createPreviewItem(item) {
      const link = document.createElement('a');
      link.className = 'cs-wishlist-menu__preview-item';
      link.href = safeLink(item.url || (item.handle ? '/products/' + encodeURIComponent(item.handle) : ''));
      link.target = '_top';

      const imageUrl = safeImage(item.image);
      if (imageUrl) {
        const image = document.createElement('img');
        image.className = 'cs-wishlist-menu__preview-image';
        image.src = imageUrl;
        image.alt = item.title || 'Mentett termék';
        image.loading = 'lazy';
        link.appendChild(image);
      } else {
        link.appendChild(createHeartPlaceholder());
      }

      const copy = document.createElement('span');
      copy.className = 'cs-wishlist-menu__preview-copy';

      if (item.vendor) {
        const vendor = document.createElement('span');
        vendor.className = 'cs-wishlist-menu__preview-vendor';
        vendor.textContent = item.vendor;
        copy.appendChild(vendor);
      }

      const title = document.createElement('span');
      title.className = 'cs-wishlist-menu__preview-title';
      title.textContent = item.title || 'Mentett illat';
      copy.appendChild(title);

      const priceText = item.price || formatPrice(item.priceValue);
      if (priceText) {
        const price = document.createElement('span');
        price.className = 'cs-wishlist-menu__preview-price';
        price.textContent = priceText;
        copy.appendChild(price);
      }

      link.appendChild(copy);
      return link;
    }

    function renderPreview(container, items) {
      if (!container) return;

      container.replaceChildren();
      const previewItems = items.filter(function (item) {
        return item.title || item.url || item.handle || item.image;
      }).slice(0, HEADER_WISHLIST_PREVIEW_COUNT);

      if (!previewItems.length) {
        container.hidden = true;
        return;
      }

      previewItems.forEach(function (item) {
        container.appendChild(createPreviewItem(item));
      });

      container.hidden = false;
    }

    function renderToggleButtons(items) {
      const activeIds = new Set(items.map(function (item) { return item.productId; }));

      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
        const productId = normalizeId(
          button.dataset.productId || button.getAttribute('data-product-id') || button.value
        );
        if (!productId) return;

        const isActive = activeIds.has(productId);
        const addLabel = button.dataset.wishlistAddLabel || 'Mentés a kívánságlistára';
        const removeLabel = button.dataset.wishlistRemoveLabel || 'Eltávolítás a kívánságlistáról';

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.setAttribute('aria-label', isActive ? removeLabel : addLabel);
        button.dataset.wishlistActive = isActive ? 'true' : 'false';
      });
    }

    function renderAll(providedItems) {
      const items = normalizeItems(providedItems || readItems());
      const count = items.length;

      document.querySelectorAll('[data-cs-wishlist-count]').forEach(function (node) {
        node.textContent = count > 99 ? '99+' : String(count);
        node.hidden = count === 0;
      });

      document.querySelectorAll('[data-cs-wishlist-count-label]').forEach(function (node) {
        node.textContent = count + ' mentett illat';
      });

      document.querySelectorAll('[data-cs-wishlist-menu-trigger]').forEach(function (trigger) {
        const baseLabel = trigger.dataset.wishlistBaseLabel || trigger.getAttribute('aria-label') || 'Kívánságlista';
        trigger.dataset.wishlistBaseLabel = baseLabel.replace(/\s*\(\d+ mentett illat\)$/, '');
        trigger.setAttribute('aria-label', trigger.dataset.wishlistBaseLabel + ' (' + count + ' mentett illat)');
        trigger.classList.toggle('has-items', count > 0);
      });

      document.querySelectorAll('[data-cs-wishlist-summary]').forEach(function (node) {
        const emptyText = node.dataset.emptyText || 'Még nincs mentett illatod.';
        const suffix = node.dataset.filledSuffix || 'mentett illat ezen az eszközön.';
        node.textContent = count === 0 ? emptyText : count + ' ' + suffix;
      });

      document.querySelectorAll('[data-cs-wishlist-empty]').forEach(function (node) {
        node.hidden = count > 0;
      });

      document.querySelectorAll('[data-cs-wishlist-preview]').forEach(function (container) {
        renderPreview(container, items);
      });

      document.querySelectorAll('[data-cs-wishlist-link-copy]').forEach(function (node) {
        const emptyCopy = node.dataset.emptyCopy || 'Wishlist oldal megnyitása';
        const filledSuffix = node.dataset.filledSuffix || 'mentett illat megtekintése';
        node.textContent = count === 0 ? emptyCopy : count + ' ' + filledSuffix;
      });

      renderToggleButtons(items);
      return items;
    }

    function itemFromElement(element) {
      const dataset = element ? element.dataset : {};
      const item = {
        productId: getDatasetValue(dataset, ['productId', 'wishlistProductId']),
        variantId: getDatasetValue(dataset, ['variantId', 'productVariantId']),
        handle: getDatasetValue(dataset, ['productHandle', 'handle']),
        url: getDatasetValue(dataset, ['productUrl', 'url']),
        title: getDatasetValue(dataset, ['productTitle', 'title']),
        vendor: getDatasetValue(dataset, ['productVendor', 'vendor', 'brand']),
        image: getDatasetValue(dataset, ['productImage', 'image']),
        price: getDatasetValue(dataset, ['productPriceFormatted', 'priceFormatted']),
        compareAtPrice: getDatasetValue(dataset, ['productComparePriceFormatted', 'comparePriceFormatted']),
        priceValue: getDatasetValue(dataset, ['productPrice', 'priceValue', 'price']),
        compareAtPriceValue: getDatasetValue(dataset, ['productComparePrice', 'compareAtPriceValue']),
        available: getDatasetValue(dataset, ['productAvailable', 'available']),
        preorder: getDatasetValue(dataset, ['productPreorder', 'preorder']),
        soldOut: getDatasetValue(dataset, ['productSoldOut', 'soldOut']),
        status: getDatasetValue(dataset, ['productStatus', 'status']),
        ratingValue: getDatasetValue(dataset, ['productRating', 'ratingValue']),
        ratingCount: getDatasetValue(dataset, ['productRatingCount', 'ratingCount']),
        fragranceFamily: getDatasetValue(dataset, ['productFragranceFamily', 'fragranceFamily']),
        usageTime: getDatasetValue(dataset, ['productUsageTime', 'usageTime']),
        season: getDatasetValue(dataset, ['productSeason', 'season']),
        gender: getDatasetValue(dataset, ['productGender', 'gender']),
        stockQuantity: getDatasetValue(dataset, ['productStockQuantity', 'stockQuantity']),
        stockQuantityIsLive: getDatasetValue(dataset, ['productStockLive', 'stockQuantityIsLive']),
        expectedArrival: getDatasetValue(dataset, ['productExpectedArrival', 'expectedArrival']),
        tags: getDatasetValue(dataset, ['productTags', 'tags']),
        addedAt: Date.now()
      };

      return normalizeItem(item);
    }

    const api = {
      version: '2.0.0',
      storageKey: STORAGE_KEY,
      updateEvent: UPDATE_EVENT,
      toggleEvent: TOGGLE_EVENT,
      normalizeItem: normalizeItem,
      normalizeItems: normalizeItems,
      itemFromElement: itemFromElement,
      formatPrice: formatPrice,
      getItems: function () {
        return readItems();
      },
      getItem: function (productId) {
        const normalizedId = normalizeId(productId);
        return readItems().find(function (item) { return item.productId === normalizedId; }) || null;
      },
      count: function () {
        return readItems().length;
      },
      has: function (productId) {
        const normalizedId = normalizeId(productId);
        return readItems().some(function (item) { return item.productId === normalizedId; });
      },
      setItems: function (items, source) {
        return writeItems(items, source || 'set-items');
      },
      add: function (product, source) {
        const item = normalizeItem(product);
        if (!item) return readItems();

        const items = readItems();
        const existingIndex = items.findIndex(function (current) {
          return current.productId === item.productId;
        });

        if (existingIndex >= 0) {
          const existing = items[existingIndex];
          items[existingIndex] = Object.assign({}, existing, item, {
            addedAt: existing.addedAt || item.addedAt || Date.now()
          });
        } else {
          items.unshift(item);
        }

        return writeItems(items, source || 'add');
      },
      remove: function (productId, source) {
        const normalizedId = normalizeId(productId);
        return writeItems(readItems().filter(function (item) {
          return item.productId !== normalizedId;
        }), source || 'remove');
      },
      toggle: function (product, source) {
        const item = normalizeItem(product);
        if (!item) return { added: false, items: readItems(), count: readItems().length };

        const exists = api.has(item.productId);
        const items = exists
          ? api.remove(item.productId, source || 'toggle-remove')
          : api.add(item, source || 'toggle-add');
        const detail = { added: !exists, item: item, items: items, count: items.length };

        window.dispatchEvent(new CustomEvent(TOGGLE_EVENT, { detail: detail }));
        return detail;
      },
      clear: function (source) {
        return writeItems([], source || 'clear');
      },
      refresh: function () {
        return renderAll();
      },
      subscribe: function (callback) {
        if (typeof callback !== 'function') return function () {};
        const handler = function (event) { callback(event.detail || {}); };
        window.addEventListener(UPDATE_EVENT, handler);
        return function () { window.removeEventListener(UPDATE_EVENT, handler); };
      }
    };

    window.CsuriWishlist = api;

    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-wishlist-toggle]');
      if (!button || button.disabled) return;

      const item = itemFromElement(button);
      if (!item) return;

      event.preventDefault();
      event.stopPropagation();
      api.toggle(item, 'product-card');
    });

    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY || LEGACY_STORAGE_KEYS.includes(event.key)) {
        const items = renderAll();
        dispatchUpdate(items, 'storage');
      }
    });

    window.addEventListener(UPDATE_EVENT, function (event) {
      renderAll(event.detail && event.detail.items ? event.detail.items : undefined);
    });

    document.addEventListener('shopify:section:load', function () {
      renderAll();
    });

    renderAll();
  })();




  (function () {
    const root = document.documentElement;
    const storageKey = 'cs-theme';

    const mediaSelector = [
      '[data-cs-light-src]',
      '[data-cs-dark-src]',
      '[data-cs-light-srcset]',
      '[data-cs-dark-srcset]',
      '[data-cs-light-bg]',
      '[data-cs-dark-bg]',
      '[data-light-src]',
      '[data-dark-src]',
      '[data-light-srcset]',
      '[data-dark-srcset]',
      '[data-light-bg]',
      '[data-dark-bg]',
      '[data-theme-light-src]',
      '[data-theme-dark-src]',
      '[data-theme-light-srcset]',
      '[data-theme-dark-srcset]',
      '[data-theme-light-bg]',
      '[data-theme-dark-bg]',
      '[data-cs-theme-image]'
    ].join(',');

    let mutationTicking = false;

    function normalizeTheme(theme) {
      return theme === 'dark' ? 'dark' : 'light';
    }

    function getStoredTheme() {
      try {
        return normalizeTheme(localStorage.getItem(storageKey));
      } catch (error) {
        return 'light';
      }
    }

    function setStoredTheme(theme) {
      try {
        localStorage.setItem(storageKey, normalizeTheme(theme));
      } catch (error) {}
    }

    function getCurrentTheme() {
      return normalizeTheme(root.getAttribute('data-cs-theme') || getStoredTheme());
    }

    function setDocumentTheme(theme) {
      const normalizedTheme = normalizeTheme(theme);
      const isDark = normalizedTheme === 'dark';

      root.setAttribute('data-cs-theme', normalizedTheme);
      root.classList.toggle('cs-dark-mode', isDark);

      if (document.body) {
        document.body.setAttribute('data-cs-theme', normalizedTheme);
        document.body.classList.toggle('cs-dark-mode', isDark);
      }
    }

    function updateToggleUI(theme) {
      const normalizedTheme = normalizeTheme(theme);
      const isDark = normalizedTheme === 'dark';

      document.querySelectorAll('[data-cs-theme-toggle]').forEach(function (toggle) {
        const text = toggle.querySelector('[data-cs-theme-toggle-text]');
        const icon = toggle.querySelector('[data-cs-theme-toggle-icon]');

        toggle.setAttribute('aria-pressed', isDark ? 'true' : 'false');
        toggle.setAttribute('aria-label', isDark ? 'Világos mód bekapcsolása' : 'Sötét mód bekapcsolása');

        if (text) {
          text.textContent = isDark ? 'Világos mód' : 'Sötét mód';
        }

        if (icon) {
          icon.textContent = isDark ? '☀' : '☾';
        }
      });
    }

    function getFirstAttr(element, names) {
      for (let i = 0; i < names.length; i += 1) {
        const value = element.getAttribute(names[i]);

        if (value !== null && value !== '') {
          return value;
        }
      }

      return '';
    }

    function setAttrIfNeeded(element, attrName, value) {
      if (!value) return;

      if (element.getAttribute(attrName) !== value) {
        element.setAttribute(attrName, value);
      }
    }

    function rememberInitialImageValues(element) {
      if (!element) return;

      const tagName = element.tagName ? element.tagName.toLowerCase() : '';

      if ((tagName === 'img' || tagName === 'source') && !getFirstAttr(element, ['data-cs-light-src', 'data-light-src', 'data-theme-light-src'])) {
        const currentSrc = element.getAttribute('src');

        if (currentSrc) {
          element.setAttribute('data-cs-light-src', currentSrc);
        }
      }

      if ((tagName === 'img' || tagName === 'source') && !getFirstAttr(element, ['data-cs-light-srcset', 'data-light-srcset', 'data-theme-light-srcset'])) {
        const currentSrcset = element.getAttribute('srcset');

        if (currentSrcset) {
          element.setAttribute('data-cs-light-srcset', currentSrcset);
        }
      }

      if (!getFirstAttr(element, ['data-cs-light-bg', 'data-light-bg', 'data-theme-light-bg'])) {
        const inlineBg = element.style && element.style.backgroundImage ? element.style.backgroundImage : '';
        let computedBg = '';

        try {
          computedBg = window.getComputedStyle(element).backgroundImage;
        } catch (error) {}

        const bgToStore = inlineBg && inlineBg !== 'none' ? inlineBg : computedBg;

        if (bgToStore && bgToStore !== 'none') {
          element.setAttribute('data-cs-light-bg', bgToStore);
        }
      }
    }

    function normalizeBackgroundValue(value) {
      if (!value) return '';

      const trimmedValue = String(value).trim();

      if (!trimmedValue || trimmedValue === 'none') {
        return '';
      }

      if (
        trimmedValue.indexOf('url(') === 0 ||
        trimmedValue.indexOf('linear-gradient(') === 0 ||
        trimmedValue.indexOf('radial-gradient(') === 0 ||
        trimmedValue.indexOf('conic-gradient(') === 0
      ) {
        return trimmedValue;
      }

      return 'url("' + trimmedValue.replace(/"/g, '\\"') + '")';
    }

    function swapElementMedia(element, theme) {
      if (!element) return;

      const normalizedTheme = normalizeTheme(theme);
      const isDark = normalizedTheme === 'dark';
      const tagName = element.tagName ? element.tagName.toLowerCase() : '';

      rememberInitialImageValues(element);

      const lightSrc = getFirstAttr(element, ['data-cs-light-src', 'data-light-src', 'data-theme-light-src']);
      const darkSrc = getFirstAttr(element, ['data-cs-dark-src', 'data-dark-src', 'data-theme-dark-src']);
      const lightSrcset = getFirstAttr(element, ['data-cs-light-srcset', 'data-light-srcset', 'data-theme-light-srcset']);
      const darkSrcset = getFirstAttr(element, ['data-cs-dark-srcset', 'data-dark-srcset', 'data-theme-dark-srcset']);

      const nextSrc = isDark && darkSrc ? darkSrc : lightSrc;
      const nextSrcset = isDark && darkSrcset ? darkSrcset : lightSrcset;

      if ((tagName === 'img' || tagName === 'source') && nextSrc) {
        setAttrIfNeeded(element, 'src', nextSrc);
      }

      if ((tagName === 'img' || tagName === 'source') && nextSrcset) {
        setAttrIfNeeded(element, 'srcset', nextSrcset);
      }

      const lightBg = getFirstAttr(element, ['data-cs-light-bg', 'data-light-bg', 'data-theme-light-bg']);
      const darkBg = getFirstAttr(element, ['data-cs-dark-bg', 'data-dark-bg', 'data-theme-dark-bg']);
      const nextBg = normalizeBackgroundValue(isDark && darkBg ? darkBg : lightBg);

      if (nextBg && element.style.backgroundImage !== nextBg) {
        element.style.backgroundImage = nextBg;
      }

      if (!nextBg && (lightBg || darkBg)) {
        element.style.backgroundImage = '';
      }

      const themeImage = element.getAttribute('data-cs-theme-image');

      if (themeImage === 'light' || themeImage === 'dark') {
        element.hidden = themeImage !== normalizedTheme;
        element.setAttribute('aria-hidden', themeImage === normalizedTheme ? 'false' : 'true');
      }
    }

    function syncThemeMedia(theme) {
      const normalizedTheme = normalizeTheme(theme);

      document.querySelectorAll(mediaSelector).forEach(function (element) {
        swapElementMedia(element, normalizedTheme);
      });
    }

    function dispatchThemeChange(theme) {
      try {
        document.dispatchEvent(
          new CustomEvent('cs-theme-change', {
            detail: {
              theme: normalizeTheme(theme)
            }
          })
        );
      } catch (error) {}
    }

    function applyTheme(theme, options) {
      const normalizedTheme = normalizeTheme(theme);
      const settings = options || {};

      setDocumentTheme(normalizedTheme);
      updateToggleUI(normalizedTheme);
      syncThemeMedia(normalizedTheme);

      if (!settings.silent) {
        dispatchThemeChange(normalizedTheme);
      }
    }

    function scheduleThemeMediaSync() {
      if (mutationTicking) return;

      mutationTicking = true;

      window.requestAnimationFrame(function () {
        mutationTicking = false;
        applyTheme(getCurrentTheme(), { silent: true });
      });
    }

    window.CsuriTheme = window.CsuriTheme || {};
    window.CsuriTheme.getTheme = getCurrentTheme;
    window.CsuriTheme.applyTheme = function (theme) {
      setStoredTheme(theme);
      applyTheme(theme);
    };
    window.CsuriTheme.syncThemeMedia = function () {
      syncThemeMedia(getCurrentTheme());
    };

    applyTheme(getStoredTheme(), { silent: true });

    if (!window.__csuriThemeControllerInitialized) {
      window.__csuriThemeControllerInitialized = true;

      document.addEventListener('click', function (event) {
        const toggle = event.target.closest('[data-cs-theme-toggle]');

        if (!toggle) return;

        const currentTheme = getCurrentTheme();
        const nextTheme = currentTheme === 'dark' ? 'light' : 'dark';

        setStoredTheme(nextTheme);
        applyTheme(nextTheme);
      });

      document.addEventListener('DOMContentLoaded', function () {
        applyTheme(getStoredTheme(), { silent: true });
      });

      document.addEventListener('shopify:section:load', function () {
        applyTheme(getStoredTheme(), { silent: true });
      });

      window.addEventListener('pageshow', function () {
        applyTheme(getStoredTheme(), { silent: true });
      });

      if ('MutationObserver' in window) {
        const startObserver = function () {
          if (!document.body) return;

          const observer = new MutationObserver(function (mutations) {
            let shouldSync = false;

            mutations.forEach(function (mutation) {
              if (shouldSync) return;

              if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length) {
                shouldSync = true;
              }

              if (mutation.type === 'attributes') {
                const target = mutation.target;

                if (target && target.matches && target.matches(mediaSelector)) {
                  shouldSync = true;
                }
              }
            });

            if (shouldSync) {
              scheduleThemeMediaSync();
            }
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
              'data-cs-light-src',
              'data-cs-dark-src',
              'data-cs-light-srcset',
              'data-cs-dark-srcset',
              'data-cs-light-bg',
              'data-cs-dark-bg',
              'data-light-src',
              'data-dark-src',
              'data-light-srcset',
              'data-dark-srcset',
              'data-light-bg',
              'data-dark-bg',
              'data-theme-light-src',
              'data-theme-dark-src',
              'data-theme-light-srcset',
              'data-theme-dark-srcset',
              'data-theme-light-bg',
              'data-theme-dark-bg',
              'data-cs-theme-image'
            ]
          });
        };

        if (document.body) {
          startObserver();
        } else {
          document.addEventListener('DOMContentLoaded', startObserver);
        }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
